export const QUESTION = 'question';
export const NEXT_PAGE = 'next_page';
export const LABEL = 'label';
export const SUBMIT = 'submit';
export const FOOTER = 'footer';
export const LINK_BUTTON = 'button_link';
export const GAUGE = 'gauge';
